import { useEffect, useRef, useState } from "react";

export function useStickyBorder() {
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    if (!sentinelRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsStuck(!entry.isIntersecting);
      },
      { threshold: [1] }
    );

    observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, []);

  return {
    sentinelRef,
    isStuck,
  };
}
